<template>
  <div class="container">
    <div class="card" v-for="(j, index) in job" :key="j.title + index">
      <span class="title">{{ j.title }}</span>
      <span class="sub-title">อัพเดต {{ changeDate(j.updatedAt) }}</span>
      <div class="data-container _mgt-8">
        <div class="header">แพ็กเกจ :</div>
        <div class="detail">{{ j.caregiverName }}</div>
      </div>
      <div class="data-container _mgt-8">
        <div class="header">ระยะเวลา :</div>
          <div class="line-container">
          <div class="detail" v-for="(time, index) in j.dates" :key="time+index">{{ time }}</div>
        </div>
      </div>
      <div class="data-container _mgt-8">
        <div class="header light">ราคาที่จ่ายผู้ดูแล : </div>
        <div class="detail light">{{ j.price }}</div>
      </div>
      <div class="data-container _mgt-8">
        <div class="header light">{{ j.totalShift }} :</div>
        <div class="detail light">{{ j.totalPrice }}</div>
      </div>
      <div class="data-container _mgt-8" v-if="j.reasonOfRemoveCGShift !== ''">
        <div class="header">สาเหตุที่ลบเวรผู้ดูแล :</div>
        <div class="detail">{{ j.reasonOfRemoveCGShift }}</div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
</style>

<style lang="scss" scoped>
  .container {
    background: #FFFFFF;
  }
  .card {
    padding: 48px 56px;
    display: flex;
    flex-direction: column;

    .title {
      font-family: 'Sukhumvit-Bold';
      line-height: 25px;
      font-size: 22px;
      color: #434B61;
    }

    .sub-title {
      margin-top: 4px;
      font-family: 'Sukhumvit-Medium';
      line-height: 19px;
      font-size: 12px;
      color: #A2A7B3;
      margin-bottom: 16px;
    }

    .data-container {
      display: flex;
      flex-direction: row;

      .header {
        flex: 1;
        font-family: 'Sukhumvit-Bold';
        font-size: 14px;
        line-height: 20px;
        color: #434B61;
        font-weight: 600;
      }

      .detail {
        flex: 1;
        font-family: 'Sukhumvit-Medium';
        font-size: 14px;
        line-height: 20px;
        color: #434B61;
      }

      .line-container {
        display: flex;
        flex-direction: column;
        flex: 1;
      }

      .light {
        color: #A2A7B2 !important;
      }

      &._mgt-8 {
        margin-top: 8px;
      }
    }

    &:not(:first-child) {
      padding-top: 28px !important;
    }
  }
</style>

<script>
import moment from 'moment'

export default {
  name: 'SectionJob',
  data () {
    return {
    }
  },
  props: {
    job: {
      type: Array,
      required: true,
    },
  },
  computed: {
  },
  methods: {
    changeDate (date) {
      return moment(date).format('DD/MM/YYYY, HH:mm')
    },
  },
}
</script>
